import { apiFetch } from './apiClient.js';

export interface MetricSeries {
  id: string;
  label: string;
  timestamps: string[];
  values: number[];
}

export interface MetricsResponse {
  tenantId: string;
  from: string;
  to: string;
  periodSec: number;
  series: MetricSeries[];
  summary: Record<string, { total: number; avg: number; last: number }>;
  _note: string;
}

export async function getMetrics(
  tenantId: string,
  opts: { from?: string; to?: string; periodSec?: number } = {},
): Promise<MetricsResponse> {
  const params: string[] = [];
  if (opts.from) params.push(`from=${encodeURIComponent(opts.from)}`);
  if (opts.to) params.push(`to=${encodeURIComponent(opts.to)}`);
  if (opts.periodSec) params.push(`period=${opts.periodSec}`);
  const qs = params.length ? `?${params.join('&')}` : '';
  return apiFetch<MetricsResponse>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/metrics${qs}`,
  );
}
